import { Instagram, Mail, Phone } from "lucide-react";

export default function Footer() {
  return (
    <footer
      data-testid="site-footer"
      className="relative border-t border-white/5 py-16 md:py-24"
    >
      <div className="mx-auto max-w-[1400px] px-6 md:px-10 lg:px-16">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-10">
          <div className="md:col-span-6">
            <div className="flex items-center gap-2">
              <div className="w-8 h-8 rounded-full bg-white text-black grid place-items-center font-display font-black text-sm">H</div>
              <span className="font-display font-semibold tracking-tight text-white text-lg">HeroWebDesign</span>
            </div>
            <p className="mt-6 max-w-md text-sm text-zinc-400 leading-relaxed">
              A one-person studio by Alex Wilson — designing and building calm, useful websites for founders and small businesses.
            </p>
            <a
              href="https://calendly.com/alixwilson112009/new-meeting"
              target="_blank"
              rel="noopener noreferrer"
              data-testid="footer-book-call"
              className="mt-6 inline-flex items-center gap-2 rounded-full border border-indigo-500/40 bg-indigo-500/10 text-indigo-200 hover:bg-indigo-500/20 hover:text-white px-4 py-2 text-sm transition"
            >
              Book a free discovery call →
            </a>
          </div>

          <div className="md:col-span-3">
            <p className="text-xs font-mono uppercase tracking-[0.25em] text-zinc-500 mb-4">Studio</p>
            <ul className="space-y-2 text-sm">
              <li><a href="#services" className="text-zinc-300 hover:text-white transition">Services</a></li>
              <li><a href="#about" className="text-zinc-300 hover:text-white transition">About</a></li>
              <li><a href="#estimator" className="text-zinc-300 hover:text-white transition">Estimator</a></li>
              <li><a href="#contact" className="text-zinc-300 hover:text-white transition">Contact</a></li>
            </ul>
          </div>

          <div className="md:col-span-3">
            <p className="text-xs font-mono uppercase tracking-[0.25em] text-zinc-500 mb-4">Get in touch</p>
            <ul className="space-y-3 text-sm">
              <li>
                <a href="mailto:HeroWebDesign@gmail.com" data-testid="footer-email" className="flex items-center gap-2 text-zinc-300 hover:text-white transition">
                  <Mail size={14} /> HeroWebDesign@gmail.com
                </a>
              </li>
              <li>
                <a href="tel:+15097747789" data-testid="footer-phone" className="flex items-center gap-2 text-zinc-300 hover:text-white transition">
                  <Phone size={14} /> (509) 774-7789
                </a>
              </li>
              <li>
                <a
                  href="https://instagram.com/herowebdesigns"
                  target="_blank"
                  rel="noopener noreferrer"
                  data-testid="footer-instagram"
                  className="flex items-center gap-2 text-zinc-300 hover:text-white transition"
                >
                  <Instagram size={14} /> @herowebdesigns
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-16 pt-8 border-t border-white/5 flex flex-col md:flex-row items-start md:items-center justify-between gap-4">
          <p className="text-xs font-mono uppercase tracking-widest text-zinc-500">
            © {new Date().getFullYear()} HeroWebDesign · Alex Wilson
          </p>
          <p className="text-xs font-mono uppercase tracking-widest text-zinc-500">
            Booking new work
          </p>
        </div>
      </div>
    </footer>
  );
}
